export const validationOnlyNumber = (event: any): void => {
	const code = event.which || event.keyCode;

	// Allowing: backspace, arrows, home, end, Ctrl+A
	if (
		[46, 8, 37, 39, 36, 35].includes(code) ||
		(code === 65 && (event.ctrlKey === true || event.metaKey === true))
	) {
		return;
	}

	// Blocking special characters
	if (event.shiftKey || code < 48 || (code > 57 && code < 96) || code > 105) {
		event.preventDefault();
	}
};
